import getOrientationString from './getOrientationString.js';
import invertOrientationString from './invertOrientationString.js';

const orientation = {
  getOrientationString,
  invertOrientationString
};

export default orientation;
